import { init, backButton, mainButton, retrieveRawInitData } from '@tma.js/sdk-react';

let initialized = false;

export function initTelegram() {
    if (initialized) return true;

    try {
        init();
        backButton.mount();
        mainButton.mount();
        initialized = true;
        return true;
    } catch (e) {
        console.warn('Telegram SDK init failed (not in Telegram?):', e);
        return false;
    }
}

export function isInTelegram(): boolean {
    return initialized;
}

export function useTelegram() {
    const initData = isInTelegram() ? retrieveRawInitData() : null;
    return { initData };
}
